import _extends from "@babel/runtime-corejs3/helpers/extends";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof _Object$getOwnPropertySymbols === "function") for (var i = 0, p = _Object$getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import React, { useContext, useRef } from 'react';
import classNames from 'classnames';
import ConfigContext from '../config-provider/ConfigContext';
import { getCompProps } from '../_utils';
import DefaultEmptyImg from './defaultEmptyImg';
import IllustrationEmptyImg from './illustrationEmptyImg';
var defaultEmptyImg = /*#__PURE__*/React.createElement(DefaultEmptyImg, null);
var illustrationEmptyImg = /*#__PURE__*/React.createElement(IllustrationEmptyImg, null);
var InteranalEmpty = function InteranalEmpty(props, ref) {
  var _useContext = useContext(ConfigContext),
    getPrefixCls = _useContext.getPrefixCls,
    prefixCls = _useContext.prefixCls,
    userDefaultProps = _useContext.compDefaultProps,
    locale = _useContext.locale;
  var emptyProps = getCompProps('Empty', userDefaultProps, props);
  var className = emptyProps.className,
    description = emptyProps.description,
    _emptyProps$image = emptyProps.image,
    image = _emptyProps$image === void 0 ? defaultEmptyImg : _emptyProps$image,
    imageStyle = emptyProps.imageStyle,
    style = emptyProps.style,
    customPrefixcls = emptyProps.prefixCls,
    children = emptyProps.children,
    others = __rest(emptyProps, ["className", "description", "image", "imageStyle", "style", "prefixCls", "children"]);
  var emptyPrefixCls = getPrefixCls(prefixCls, 'empty', customPrefixcls);
  var emptyLangMsg = locale.getCompLangMsg({
    componentName: 'Empty'
  });
  // ref
  var thisEmptyRef = useRef();
  var emptyRef = ref || thisEmptyRef;
  var imgClasses = classNames("".concat(emptyPrefixCls, "-image"));
  var imgNode = typeof image === 'string' ? /*#__PURE__*/React.createElement("img", {
    src: image,
    className: imgClasses,
    style: imageStyle,
    alt: "empty"
  }) : typeof image === 'boolean' ? null : /*#__PURE__*/React.cloneElement(image, {
    style: imageStyle
  });
  var descriptionNode = description === undefined ? /*#__PURE__*/React.createElement("div", {
    className: "".concat(emptyPrefixCls, "-description")
  }, emptyLangMsg.emptyText) : description ? /*#__PURE__*/React.createElement("div", {
    className: "".concat(emptyPrefixCls, "-description")
  }, description) : null;
  var emptyFooter = children ? /*#__PURE__*/React.createElement("div", {
    className: "".concat(emptyPrefixCls, "-footer")
  }, children) : null;
  var emptyClasses = classNames(emptyPrefixCls, className);
  return /*#__PURE__*/React.createElement("div", _extends({
    ref: emptyRef,
    className: emptyClasses,
    style: style
  }, others), imgNode, descriptionNode, emptyFooter);
};
var Empty = /*#__PURE__*/React.forwardRef(InteranalEmpty);
Empty.displayName = 'Empty';
Empty.DEFAULT_IMG = defaultEmptyImg;
Empty.ILLUSTRATION_IMG = illustrationEmptyImg;
export default Empty;